import React from 'react';

function Home() {
  return (
    <div>
      <h1>Home Page</h1>
      <p>Welcome to the homepage!</p>
    </div>
  );
}

export default Home;
